import React from 'react';
import { Loader2 } from 'lucide-react';

interface ButtonProps {
  children: React.ReactNode;
  onClick?: () => void;
  variant?: 'primary' | 'secondary' | 'outline' | 'danger' | 'success' | 'premium';
  fullWidth?: boolean;
  disabled?: boolean;
  type?: 'button' | 'submit' | 'reset';
  className?: string;
  loading?: boolean;
}

export const Button: React.FC<ButtonProps> = ({
  children,
  onClick,
  variant = 'primary',
  fullWidth = false,
  disabled = false,
  type = 'button',
  className = '',
  loading = false
}) => {
  const base = "py-4 px-6 rounded-full font-bold text-sm tracking-wide transition-all active:scale-95 flex items-center justify-center gap-2 backdrop-blur-md disabled:opacity-50 disabled:cursor-not-allowed border";
  const variants = {
    primary: "bg-white text-black border-white hover:bg-gray-200", 
    secondary: "bg-black border-white text-white hover:bg-white/10",
    outline: "bg-transparent border-white/50 text-white hover:border-white hover:bg-white/5",
    danger: "bg-red-500 border-red-500 text-white hover:bg-red-600",
    success: "bg-green-500 border-green-500 text-white hover:bg-green-600",
    premium: "bg-gradient-to-r from-purple-500 to-pink-500 border-transparent text-white hover:opacity-90",
  };

  return (
    <button 
      type={type} 
      onClick={onClick} 
      disabled={disabled || loading}
      className={`${base} ${variants[variant]} ${fullWidth ? 'w-full' : ''} ${className}`}
    >
      {loading ? <Loader2 className="animate-spin" size={20} /> : children}
    </button>
  );
};